import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import Gallery from "../../components/Gallery/Gallery";
import CTAOne from "../../components/CTA/CTAOne";




const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef(); 
  const rentals = useRef();
  const contact = useRef();

  const scrollToSection = (e, content) => {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
          break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className=" mt-minus-50">
        <div className="container mt-minus-50">
      <div className="row mt-minus-50">
        <HeadingSection
       
          classAppend="dark-color"
        > <h2>INFORMATION FOR SELLERS</h2></HeadingSection>
      </div>
     
<p>Most sellers think they are hiring a brokerage firm when in fact they are hiring an agent who is an independent contractor. The agent is responsible for setting their own hours, work schedule and vacation days and maintaining their own profit-and-loss statement. The fact is that 99.9% of agents are independent contractors who work for themselves and act as franchisees, utilizing the marketing materials and branding of the brokerage firm that they are affiliated with. Sellers are dependent on an agent’s skill, advice, business strategy, marketing, availability and professionalism; thus, choosing the right agent is critical to success. At Olshan Realty, we are a boutique company, and we work as a team. We confer with one another, and most of our agents have been with the firm for over 20 years. We are well-versed on the types of properties, locations and management companies, and have deep broker contacts at other firms.</p>

<h3>The roadmap to achieving the highest and best price in a timely manner involves: </h3>
<ol>
<li>Pricing the property competitively compared to properties that are on the market. </li>
<li>Evaluating comparable recently sold properties. </li>
<li>Presenting the property in the best light, which might include staging, painting, some renovations and clearing the clutter.  </li>
<li>Designing a marketing strategy, including brochures with professional photography, floorplans and immediately listing on the Multiple Listing Services (MLS) and other websites. For maximum exposure, Olshan belongs to 2 MLSes: the Real Estate Board of New York (REBNY) Listing Service (RLS). and to OneKey MLS which covers Manhattan, Westchester, Long Island, Rockland, Putnam, Dutchess, Orange, Ulster and Sullivan Counties.</li>
<li>Social media: employing Facebook, Instagram and Reels  </li>
<li>Availability: A seller must make the property available to show and the broker must commit to being available to show when requested. </li>
<li>Due Diligence: It is important to have all the necessary documents available on Day 1 of marketing, so time is not lost. For co-ops and condos, documents include offering plans, amendments, financials, list of assessments, building information and amenities, alteration agreements, latest tax statements and Department of Building sign offs.</li>
<li>Closing Costs: Providing a complete list of costs and fees up front from managing agents, co-op and condo boards, state and city recording taxes etc. are important so that parties are prepared and understand the numbers.   </li>
<li>Open Houses: If the owner is comfortable with an open house and if the building rules allows it. </li>
</ol>

<h3>STAGING</h3>
<p>Presenting a property in its best light can be a challenge. It often means clearing the clutter, doing work and incurring costs. But an investment in quality staging can often result in hundreds of thousands over what the seller would have otherwise achieved. Case studies at Olshan Realty show how critical staging has been in terms of velocity of sale and price. We use an array of stagers at different price levels and we advise throughout the process. </p>

<h3>ACHIEVING THE HIGHEST AND BEST PRICE: REALITY vs. MYTH</h3>

<p>Some agents and a few brokerage firms attempt to convince sellers to use a private network of their own brokers. This is known as Off Market marketing, Pre-marketing, Private Exclusives, Private Brokerage and various other names. An Off Market listing is often a euphemism for Overpriced; it is a marketplace of sellers test-driving unrealistically high prices while their agents counsel them to ignore racking up days on the market; meanwhile the seller is frittering away valuable time. The bottom line: It’s an old self-serving hustle by agents and firms looking to earn the entire commission without co-brokering. It is a faulty strategy that has nothing to do with a seller achieving the highest and best price. </p>

<p>In my over 45 years of experience, the best results are achieved by pricing the property correctly, presenting it in its best light, and immediately marketing to the entire brokerage community to generate maximum activity and create an auction effect. </p>

  <i>---Donna Olshan</i>


    </div>
    </section>
    <Gallery
        title="MORE FEATURED PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={sales}
      />

      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />

<CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan publishes a report covering all the contract activity in the luxury market on properties at $4 million and above. The free report draws subscribers from all over the world, and is frequently quoted in the New York Times, Wall Street Journal, Crain's, Observer, The Real Deal and various media outlets. 
      </CTAOne>
      <FooterOne />
    </Loader>
  );
};



export default Architecture;
